import React, { Component } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import "./App.css";
import "react-dates/initialize";
// Styles
// CoreUI Icons Set
import "@coreui/icons/css/coreui-icons.min.css";
// Import Flag Icons Set
import "flag-icon-css/css/flag-icon.min.css";
// Import Font Awesome Icons Set
import "font-awesome/css/font-awesome.min.css";
// Import Simple Line Icons Set
import "simple-line-icons/css/simple-line-icons.css";
// Import Main styles for this application
import "./scss/style.css";

// Containers
import { DefaultLayout } from "./containers";
// Pages
import { Login /*Page404, Page500, Register*/ } from "./views/Pages";

import RequestManager from "./singletons/RequestManager";

// import { renderRoutes } from 'react-router-config';
import { SDK_NGX_ASHWA } from "./config/Constants";

let player;

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      soundPlayStatus: false,
      loginMode: null,
      checkActiveOrderScreen: false,
      playSound: false,
    };
  }

  componentDidMount() {
    let loginMode = localStorage.getItem("loginMode");
    if (loginMode !== null) {
      // it should be equal
      if (loginMode === "concessionaire") {
        // this.props.history.push("/inventoryapprove");
      } else {
        player = document.getElementById("audio");
        // this.fetchOrderInterval = setInterval(() => {
        //   this.fetchOrders()
        // }, TIME_INTERVAL_ORDER);
        // this.fetchOrders()
      }
    }
    this.requestNotificationPermission();
  }

  componentWillUnmount() {
    // clearInterval(this.fetchOrderInterval)
  }
  playSound = () => {
    if (player !== null) {
      if (player.paused === true) {
        let requestManager = new RequestManager();
        console.log("sound app.js" + requestManager.getSoundFile());
        player.src = require("./assets/sounds/" +
          requestManager.getSoundFile() +
          ".mp3");
        player.load();
        player.play();
      }
    }
  };
  fetchOrders = async () => {
    let requestManager = new RequestManager();
    if (requestManager.getCheckActiveOrders() === false) {
      let storeInformation = JSON.parse(
        localStorage.getItem("storeInformation")
      );
      let params = {};

      if (storeInformation !== null) {
        let loginMode = localStorage.getItem("loginMode");
        // it should be equal
        if (loginMode === "concessionaire") {
          this.props.history.push("/ordersummary");
        } else {
          if (loginMode === "store") {
            params = {
              storeId: storeInformation.store && storeInformation.store.id,
            };
          } else {
            params = {
              merchantId:
                storeInformation.merchant && storeInformation.merchant.id,
            };
          }
          if (
            storeInformation.store &&
            storeInformation.store.showArrived === true
          ) {
            let response = await requestManager.getResponseFromPredefinedQuery(
              "getOrders",
              params
            );

            if (response.error === null) {
              this.setState({
                orderData: response.data,
                newOrders: response.data.newOrders,
                acceptedOrders: response.data.acceptedOrders,
                approachingOrders: response.data.approachingOrders,
                arrivedOrders: response.data.arrivedOrders,
              });
              if (
                storeInformation.store &&
                storeInformation.store.printSdkType !== SDK_NGX_ASHWA
              )
                player.src = require("./assets/sounds/" +
                  requestManager.getSoundFile() +
                  ".mp3");
              console.log(
                " app response active orders1",
                JSON.stringify(response.data)
              );
              try {
                this.notifiyNewOrdersUsingSoundAndNotification();
              } catch (e) {
                console.log(e);
              }
            } else {
              console.log("Connection to server failed.");
            }
          } else {
            let response = await requestManager.getResponseFromPredefinedQuery(
              "getKioskOrders",
              params
            );
            if (response.error === null) {
              let obj = {
                edges: [],
              };
              this.setState({
                orderData: response.data,
                newOrders: response.data.newOrders,
                acceptedOrders: response.data.acceptedOrders,
                approachingOrders: obj,
                arrivedOrders: obj,
              });
              // console.log("app response active orders",JSON.stringify( response.data));
              try {
                this.notifiyNewOrdersUsingSoundAndNotification();
              } catch (e) {
                console.log(e);
              }
            } else {
              console.log("Connection to server failed.");
            }
          }
        }
      }
    }
  };
  fromAndroid = (data) => {
    if (window.totDevice) {
      window.totDevice.postMessage(JSON.stringify(data));
    }
  };
  notifiyNewOrdersUsingSoundAndNotification = () => {
    let storeInformation = JSON.parse(localStorage.getItem("storeInformation"));
    let storageData = localStorage.getItem("attendedOrders");
    let attendedOrders;
    if (storageData === null) {
      attendedOrders = {
        newOrders: [],
        arrivedOrders: [],
        approachingOrders: [],
      };
    } else {
      attendedOrders = JSON.parse(storageData);
    }

    let newOrders = this.state.newOrders.edges.map(
      (order) => order.node.orderId
    );
    let newSoundOrders = newOrders.filter((order) => {
      return attendedOrders.newOrders.indexOf(order) <= -1;
    });

    let approachingOrders = this.state.approachingOrders.edges.map(
      (order) => order.node.orderId
    );
    let approachingSoundOrders = approachingOrders.filter((order) => {
      return attendedOrders.approachingOrders.indexOf(order) <= -1;
    });

    let arrivedOrders = this.state.arrivedOrders.edges.map(
      (order) => order.node.orderId
    );
    let arrivedSoundOrders = arrivedOrders.filter((order) => {
      return attendedOrders.arrivedOrders.indexOf(order) <= -1;
    });

    newSoundOrders.forEach((order) => {
      let orderDetails = this.state.newOrders.edges.find((orderDetails) => {
        return (orderDetails.node.orderId = order);
      });
      if ("Notifcation" in window) {
        if (Notification.permission === "granted") {
          new Notification(
            `New Order! Token number:${orderDetails.node.storeToken}`,
            {
              body:
                "A new order has been received at your store. Please accept it.",
              icon: require("./assets/img/brand/highlighted-logo.png"),
            }
          );
        }
      }
    });

    arrivedSoundOrders.forEach((order) => {
      let orderDetails = this.state.arrivedOrders.edges.find((orderDetails) => {
        return (orderDetails.node.orderId = order);
      });
      if ("Notification" in window) {
        if (Notification.permission === "granted") {
          new Notification(
            `Customer Arrived! Token number:${orderDetails.node.storeToken}`,
            {
              body:
                "Customer has arrived at your store. Please step out and deliver order.",
              icon: require("./assets/img/brand/highlighted-logo.png"),
            }
          );
        }
      }
    });

    if (
      newSoundOrders.length > 0 ||
      approachingSoundOrders.length > 0 ||
      arrivedSoundOrders.length > 0
    ) {
      if (
        storeInformation.store &&
        storeInformation.store.printSdkType === SDK_NGX_ASHWA
      ) {
        this.fromAndroid("play");
      } else {
        this.playSound();
      }

      localStorage.setItem(
        "attendedOrders",
        JSON.stringify({
          newOrders: attendedOrders.newOrders.concat(newSoundOrders),
          approachingOrders: attendedOrders.approachingOrders.concat(
            approachingSoundOrders
          ),
          arrivedOrders: attendedOrders.arrivedOrders.concat(
            arrivedSoundOrders
          ),
        })
      );
        let loginMode = localStorage.getItem("loginMode");
        let storeInformation = JSON.parse(localStorage.getItem("storeInformation") || "{}");
      
        if (
          loginMode === "store" &&
          storeInformation.store &&
          storeInformation.store.foodcourtCashier === true
        ) {
           console.log("foodcourt in app.js line -276")
          this.props.history.push("/activecashorders");
          
        } else {
          console.log("foodcourt in app.js line 276")
          this.props.history.push("/activeorders");
        }
      // this.props.history.push("/activeorders");
    }
  };

  requestNotificationPermission = () => {
    if ("Notification" in window) {
      if (Notification.permission === "granted") {
        return true;
      } else if (Notification.permission !== "denied") {
        Notification.requestPermission(function (permission) {
          if (permission === "granted") {
            return true;
          } else {
            return false;
          }
        });
      } else {
        return false;
      }
    }
  };

  render() {
    return (
      <div>
        <audio hidden id="audio">
          <source src={require("./assets/sounds/mute.mp3")}></source>
        </audio>
        <BrowserRouter>
          <Switch>
            <Route exact path="/login" name="Login Page" component={Login} />
            {/* <Route exact path="/register" name="Register Page" component={Register} />
                <Route exact path="/404" name="Page 404" component={Page404} />
                <Route exact path="/500" name="Page 500" component={Page500} /> */}
            <Route path="/" name="Home" component={DefaultLayout} />
          </Switch>
        </BrowserRouter>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js